import { render, staticRenderFns } from "./ResumeDisclaimer.vue?vue&type=template&id=429b0de5&scoped=true&"
import script from "./ResumeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ResumeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDisclaimer.vue?vue&type=style&index=0&id=429b0de5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429b0de5",
  null
  
)

export default component.exports